
import { RiAddLine } from 'react-icons/ri';
import { BankAccountCard } from '../../../components/UiComponents/InfoCards';
import { Button } from '../../../components/UiComponents/Ui';
import { isSupplierBankAccountComplete } from '../../helperFunctions';
import ErrorEmptyStateView from '../../../components/ErrorEmptyStateView';


const FinanceDetails = ({
  supplierData,
  setModalData,
  formErrors,
  handleRemoveBankAccount,
  handleBankModalOpen,
}) => {
  const hasIncompleteBankAccount =
    supplierData?.bankAccounts?.some(
      (b) => !isSupplierBankAccountComplete(b),
    ) || false;

  return (
    <div className=" flex flex-col items-center justify-center ">
      <div className="w-[80%] space-y-6 flex flex-col items-center ">
        {hasIncompleteBankAccount && (
          <div className="w-[90%] rounded-lg border border-warning-200 bg-warning-50 px-3 py-2 text-sm text-warning-800">
            Some required bank details are missing. Complete the bank account
            details before creating remittance.
          </div>
        )}

        {supplierData?.bankAccounts?.length ? (
          supplierData.bankAccounts.map((item, index) => (
            <BankAccountCard
              key={index}
              item={item}
              onEdit={() => {
                setModalData(item );
                handleBankModalOpen(true, index);
              }}
              detailed={true}
              onRemove={() => handleRemoveBankAccount(index)}
            />
          ))
        ) : (
          <div className="w-[90%]">
            <ErrorEmptyStateView
              title="No Bank Account Found"
              description="Please add a Bank Account to continue"
              type="empty"
            />
          </div>
        )}

        <div className="w-[90%]">
          <Button
            fullWidth
            variant="outlined"
            startIcon={<RiAddLine />}
            onClick={() => handleBankModalOpen(false, 0)}
          >
            Add Bank Account
          </Button>
          {typeof formErrors?.bankAccounts === 'string' &&
            !!formErrors?.bankAccounts &&
            !supplierData?.bankAccounts?.length && (
              <HelperText>{formErrors.bankAccounts}</HelperText>
            )}
        </div>
      </div>
    </div>
  );
};

export default FinanceDetails;